export const IP_MANAGEMENT_REQUEST = "IP_MANAGEMENT_REQUEST";
export const IP_MANAGEMENT_SUCCESS = "IP_MANAGEMENT_SUCCESS";
export const IP_MANAGEMENT_FAILURE = "IP_MANAGEMENT_FAILURE";

export const IP_ACCOUNT_LOOKUP_REQUEST = "IP_ACCOUNT_LOOKUP_REQUEST";
export const IP_ACCOUNT_LOOKUP_SUCCESS = "IP_ACCOUNT_LOOKUP_SUCCESS";
export const IP_ACCOUNT_LOOKUP_FAILURE = "IP_ACCOUNT_LOOKUP_FAILURE";
export const CLEAR_IP_ACCOUNT_LOOKUP = "CLEAR_IP_ACCOUNT_LOOKUP";
